/* @flow */
// typecheck: ignore file
import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { loadSchoolsSuccess } from 'reducers/schoolTables';
import type { LoadSchoolsAction } from 'reducers/schoolTables';
import Organization from 'entities/Organization';
import API from 'lib/RemindAPI';

type Sort = 'first_name' | 'last_name' | 'join_date' | 'role';
type SortDirection = 'desc' | 'asc';

export type SchoolFetchOptions = {
  page: number,
  perPage: number,
  sortDirection?: SortDirection,
  sort?: Sort,
};

function fetch(id: number | string, parameters: SchoolFetchOptions) {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    sort_direction: parameters.sortDirection,
    page: parameters.page,
  };

  return API.request(`/organizations/${id}/schools`, 'GET', options).then(
    response => response.schools.map(o => Organization.fromJSON(o))
  );
}

function* fetchSchools(action: LoadSchoolsAction): Generator<?any, ?any, ?any> {
  try {
    // $FlowFixMe
    const schools = yield call(fetch, action.districtId, action.options);

    if (schools) {
      yield put(loadSchoolsSuccess(action.districtId, schools, action.options));
    }
  } catch (e) {
    console.error(e);
  }
}

export default function* schoolTables(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('schoolTables/LOAD_SCHOOLS_REQUEST', fetchSchools);
}



// WEBPACK FOOTER //
// ./src/sagas/schoolTables.js